
import React, { useEffect, useState } from 'react';

// import ContactUsection from '../ContactUsection/ContactUsection';
import actions from "../../ReduxStore/actions/index";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress, Box, Grid, styled } from '@mui/material';

import AboutUsMainPage from './AboutUsMainPage/AboutUsMainPage';
import AboutUsContent from './AboutUsContent/AboutUsContent';


const AboutUsHome = () => {
    const [loading, setLoading] = useState(false);
    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const dispatch = useDispatch();
    const MapContainer = styled(Box)({
        height: "400px", // Set your desired height for the map
        width: "100%",
    });

      const { getAllAboutUsSections } = useSelector((state) => state?.getAllAboutUsSections);

      console.log(getAllAboutUsSections);


      useEffect(() => {
        const fetchData = async () => {
          const data1 = { data: {}, method: "get", apiName: "getAllAboutUsSectionsApproved" };

          setLoading(true); // Set loading to true when the request starts
          await dispatch(actions.GETALLABOUTUSSECTIONS(data1));
          setLoading(false); // Set loading to false after data is fetched
        };
        fetchData();
      }, [dispatch]);


      // Function to get dates by section_name
      const getDatesBySectionName = (sectionName) => {
        return getAllAboutUsSections?.data
          ?.filter((section) => section.section_name === sectionName)
          || [];
      };


      const bannerDates = getAllAboutUsSections?.data
        ? getDatesBySectionName('banner')
        : [];


      const aboutDates = getAllAboutUsSections?.data
        ? getDatesBySectionName('about')
        : [];

    //   const referralsDates = getAllHomeSections?.data
    //     ? getDatesBySectionName('referrals')
    //     : [];

    //   const offersDates = getAllHomeSections?.data
    //     ? getDatesBySectionName('offers')
    //     : [];


    //   const faqsDates = getAllHomeSections?.data
    //     ? getDatesBySectionName('faqs')
    //     : [];


    //   const getInTouchDates = getAllHomeSections?.data
    //     ? getDatesBySectionName('getInTouch')
    //     : [];




    //   console.log(bannerDates, "section 1");
    //   console.log(stakeNowDates, "section 2");




    return (

        <div style={{ position: "relative" }}>
            {loading ? (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100vh"
                    style={{ background: "#fff", zIndex: 10 }}
                >
                    <CircularProgress style={{ color: 'gold' }} /> {/* Gold spinner */}
                </Box>
            ) : (
                <>
                    <AboutUsMainPage bannerDates={bannerDates} />
                    <AboutUsContent aboutDates={aboutDates} />

                    {/* <ContactUsection />
                    <CustomMap /> */}
                </>
            )}

            {/* <Fab
        size="small"
        aria-label="scroll to top"
        onClick={handleScrollToTop}
        sx={{
          position: "sticky",
          bottom: 0,
          right: 0,
          // top: -30,
          borderRadius: "10px",
          boxShadow: "none",
          transform: "translateX(50%)",
          backgroundColor: "red",
          color: "#C38F51",
          "&:hover": {
            backgroundColor: "black",
            color: "white"
          },
        }}
      >
        <KeyboardArrowUpIcon />
      </Fab> */}

        </div>
    )
}


export default AboutUsHome;



